import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
  editData: [],
};

export const FaqFormSlice = createSlice({
  name: "FaqFormReducer",
  initialState,
  reducers: {
    setFaqData: (state, action) => {
      state.editData = action.payload;
    },

    resetState: (state) => {
      state.editData = {};
    },
  },
});

export const { setFaqData, resetState } = FaqFormSlice.actions;

export default FaqFormSlice.reducer;
